import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-about-us',
  templateUrl: './new-about-us.component.html',
  styleUrls: ['./new-about-us.component.scss']
})
export class NewAboutUsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
